import { render } from "./about.vue?vue&type=template&id=00837c8b&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=00837c8b&scoped=true&lang=css"

import exportComponent from "E:\\lb\\vue30\\tuiguang_meng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00837c8b"]])

export default __exports__